// extracted by mini-css-extract-plugin
module.exports = {"aurora-container":"Aurora_aurora-container__jSsUB"};